module.exports = __webpack_public_path__ + "img/spagetti.2e755ff3.png";